import {inject, Injectable} from '@angular/core';
import {MessageService} from 'primeng/api';
import {TranslocoService} from '@jsverse/transloco';
import {take} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private messageService = inject(MessageService);
  private translator = inject(TranslocoService);

  public showInfo(message: string, translated = true, sticky = false, title?: string) {
    this.show('info', 'toast.info', message, translated, sticky, title);
  }

  public showSuccess(message: string, translated = true, sticky = false, title?: string) {
    this.show('success', 'toast.success', message, translated, sticky, title);
  }

  public showError(message: string, translated = true, sticky = false, title?: string) {
    this.show('error', 'toast.error', message, translated, sticky, title);
  }

  public showWarning(message: string, translated = true, sticky = false, title?: string) {
    this.show('warn', 'toast.warning', message, translated, sticky, title);
  }

  public closeAll() {
    this.messageService.clear();
  }

  // A toast raised while the App loads (route guard, App access refused by the API) comes before
  // the translation file: wait for the active language. Once loaded, load() replays it at once.
  private show(severity: string, defaultTitle: string, message: string, translated: boolean, sticky: boolean, title?: string) {
    const add = () => {
      const detail = translated ? this.translator.translate(message) : message;
      const summary = this.translator.translate(title || defaultTitle);
      this.messageService.add({severity, summary, detail, sticky});
    };
    this.translator.load(this.translator.getActiveLang()).pipe(take(1)).subscribe({next: add, error: add});
  }
}
